module.exports = __webpack_public_path__ + "img/svs-ic.92fabd08.png";